import 'assets/css/style.css'
import 'assets/js/base.js'
import $ from 'jquery'
import dateValidation from 'assets/js/entry.js'
import gradYear from 'assets/js/gradYear.js'
import selectTab from 'assets/js/tab.js'
import telAnchor from 'assets/js/access.js'
import setTopicsYear from 'assets/js/topics.js'
import postEntryFormData from 'assets/js/postEntryForm.js'
import postContactFormData from 'assets/js/postContactForm.js'

selectTab()
telAnchor()
setTopicsYear()
if (location.pathname === '/recruit/form.html') {
  postEntryFormData()
  dateValidation()
  gradYear()
  $('#entry').find('select').val('').end()
}
if (location.pathname === '/contact/form.html') {
  postContactFormData()
}



// WEBPACK FOOTER //
// ./src/assets/js/index.js